import _t from 'i18n!nls/custom-labels';

// Hard-coded support for plurals for these week terms.
export const isPluralSupportedWeekTerm = (courseraWeek: string): boolean => {
  return courseraWeek === 'week' || courseraWeek === 'module';
};

export const capitalizeEachWord = (str: string | undefined): string | undefined => {
  if (!str) {
    return undefined;
  }

  return str.replace(/\w\S*/g, (word) => word.replace(/^\w/, (char) => char.toUpperCase()));
};

export const getCustomCourseTerm = (
  courseraCourse?: string | null,
  capitalize?: boolean,
  pluralize?: boolean
): string | undefined => {
  let customTerm;
  if (!courseraCourse) {
    customTerm = pluralize ? _t('courses') : _t('course');
  } else if (courseraCourse === 'guided project' || courseraCourse === 'project') {
    customTerm = pluralize ? _t('projects') : _t('project');
  } else {
    customTerm = courseraCourse;
  }

  return capitalize ? capitalizeEachWord(customTerm) : customTerm;
};

export const getCustomWeekTerm = (
  isModuleDefault: boolean,
  courseraWeek?: string,
  capitalize?: boolean,
  pluralize?: boolean
): string | undefined => {
  let customTerm;
  if (!courseraWeek && isModuleDefault) {
    customTerm = pluralize ? _t('modules') : _t('module');
  } else if ((!courseraWeek && !isModuleDefault) || courseraWeek?.toLowerCase() === 'week') {
    customTerm = pluralize ? _t('weeks') : _t('week');
  } else if (courseraWeek === 'project') {
    customTerm = pluralize ? _t('projects') : _t('project');
  } else if (courseraWeek === 'module') {
    customTerm = pluralize ? _t('modules') : _t('module');
  } else {
    customTerm = courseraWeek;
  }

  return capitalize ? capitalizeEachWord(customTerm) : customTerm;
};
